__turbopack_context__.v({
  "captionText": "SectionHeader-module__2hu0uq__captionText",
  "descriptionText": "SectionHeader-module__2hu0uq__descriptionText",
  "headerContainer": "SectionHeader-module__2hu0uq__headerContainer",
  "mainHeading": "SectionHeader-module__2hu0uq__mainHeading",
});
